module.exports = __webpack_public_path__ + "static/media/sneak-peek-onboarding.8ea8c7c0.png";